import { render, staticRenderFns } from "./indexDashboard.vue?vue&type=template&id=ca143032&"
import script from "./indexDashboard.vue?vue&type=script&lang=ts&"
export * from "./indexDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports